module.exports = __webpack_public_path__ + "img/SC_BG.253f8131.png";